<div class="langs-container notranslate">
    <ion-fab>

      <ion-fab-button edge>
        @if (brazilFlags?.includes(clientId) && googleTranslateService.currentLang === 'pt') {
          <img draggable="false" [src]="'/assets/isoLangs/bz.svg'" alt="bz"/>
        }
        @else if (headerLangType() === 'flags') {
          <img draggable="false" [src]="'/assets/isoLangs/' + googleTranslateService.currentLang + '.svg'" alt="{{googleTranslateService.currentLang}}"/>
        }
        @else {
          <span> {{ googleTranslateService.currentLang }} </span>
        }
      </ion-fab-button>

      <ion-fab-list side="bottom">
        @for(langs of languages(); track $index) {
          @if(langs.code != googleTranslateService.currentLang){
            <ion-fab-button size="large" (click)="changeLanguage(langs.code)">
              <div class="fab-wrapper">
                @if (brazilFlags?.includes(clientId) && langs.code === 'pt') {
                  <img draggable="false" [src]="'/assets/isoLangs/bz.svg'" alt="bz"/>
                }
                @else if(headerLangType() === 'flags'){
                  <img draggable="false" [src]="langs.img" [alt]="langs.code" />
                }@else {
                  <span> {{ langs.code }} </span>
                }
              </div>
            </ion-fab-button>
          }
        }
        @if(!isTechMode() && !isTechEditMode() && !isRegisterMode() && !isWebApp()){
          <ion-fab-button size="large" (click)="changeGoogleLanguage()">
            <img draggable="false" class="google-lang-icon" src="/assets/imgs/langs.svg" />
          </ion-fab-button>
        }
      </ion-fab-list>
      
    </ion-fab>
</div>    